export enum ForecastComponentMode {
    Forecast = 'forecast',
    Tricast = 'tricast',
    ForecastAndTricast = 'forecastAndTricast',
}
